import moment from 'moment';

export const QUALITY_CHECKS = {
  LONG_BIO: 'hasLongBio',
  PORTFOLIO_SAMPLES: 'hasEnoughPortfolioSamples',
  RECENTLY_ACTIVE: 'recentlyActive',
  HAS_LOCATION: 'hasLocation',
  HAS_ROLES_OR_SKILLS: 'hasRolesOrSkills',
};

const DAYS_180 = 180;
const DAYS_365 = 365;

const hasLongBio = (user) => {
  const bio = user?.bio || '';
  const trimmed = bio.trim();

  if (!trimmed) {
    return false;
  }

  return trimmed.length >= 150;
};

const getLastActiveDate = (user) => {
  if (!user?.last_active) {
    return null;
  }

  const date = moment(user.last_active);
  return date.isValid() ? date : null;
};

const isRecentlyActive = (user, now = moment()) => {
  const lastActive = getLastActiveDate(user);

  if (!lastActive) {
    return false;
  }

  return now.diff(lastActive, 'days') <= DAYS_180;
};

const isInactiveOver365Days = (user, now = moment()) => {
  const lastActive = getLastActiveDate(user);

  if (!lastActive) {
    return true;
  }

  return now.diff(lastActive, 'days') > DAYS_365;
};

const hasPortfolioSamples = (user) => {
  const numOfProjects = user?.stats?.num_of_projects || 0;

  return numOfProjects >= 2;
};

const hasLocation = (user) => {
  const locationText = user?.location?.text || '';

  if (!locationText) {
    return false;
  }

  return locationText !== 'Private';
};

const hasRolesOrSkills = (user) => {
  const roles = Array.isArray(user?.top_roles) ? user.top_roles : [];
  const skills = Array.isArray(user?.skills) ? user.skills : [];

  return roles.length > 0 || skills.length > 0;
};

export const computePortfolioQuality = (user, now = moment()) => {
  if (!user) {
    return {
      passedChecksCount: 0,
      passedChecks: {},
      alwaysNoindex: true,
      shouldIndex: false,
    };
  }

  const checks = {
    [QUALITY_CHECKS.LONG_BIO]: hasLongBio(user),
    [QUALITY_CHECKS.PORTFOLIO_SAMPLES]: hasPortfolioSamples(user),
    [QUALITY_CHECKS.RECENTLY_ACTIVE]: isRecentlyActive(user, now),
    [QUALITY_CHECKS.HAS_LOCATION]: hasLocation(user),
    [QUALITY_CHECKS.HAS_ROLES_OR_SKILLS]: hasRolesOrSkills(user),
  };

  const passedChecksCount = Object.keys(checks).reduce(
    (count, key) => (checks[key] ? count + 1 : count),
    0
  );

  const isDeletedOrBanned = !user.active;
  const emptyBio = !(user.bio || '').trim();
  const inactiveOver365Days = isInactiveOver365Days(user, now);
  const alwaysNoindex = isDeletedOrBanned || emptyBio || inactiveOver365Days;
  const shouldIndex = !alwaysNoindex && passedChecksCount >= 4;

  return {
    passedChecksCount,
    passedChecks: checks,
    alwaysNoindex,
    shouldIndex,
  };
};
